// src/utils/sendEmail.js
export async function sendEmail(details) {
    // Ensure a reCAPTCHA token is provided
    if (!details.token) {
        console.error("Missing reCAPTCHA token");
        throw new Error("Missing reCAPTCHA token");
    }

    const API_URL = process.env.REACT_APP_API_URL;

    if (!API_URL) {
        throw new Error("Missing REACT_APP_API_URL environment variable");
    }

    try {
        // Use URLSearchParams to safely encode the form body
        const formBody = new URLSearchParams(details).toString();

        const res = await fetch(API_URL, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: formBody,
        });

        if (!res.ok) {
            const text = await res.text();
            throw new Error(`Server returned ${res.status}: ${text}`);
        }

        // If your backend returns text, not JSON, handle it gracefully
        const text = await res.text();
        return { success: true, message: text };

    } catch (err) {
        console.error("sendEmail error:", err);
        throw err; // propagate real error so Formik onSubmit.catch can handle it
    }
}
